import { Anchor, Printer, Ship, Wrench } from "lucide-react";
import { Button } from "./ui/button";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const it = (d) => (d && /^\d{4}-\d{2}-\d{2}/.test(d) ? d.slice(0, 10).split("-").reverse().join("/") : d || "");

export function buildTimeline(data) {
  const boats = (data.movements || []).map((m) => ({
    key: `b-${m.id || m.data_check_in}`, kind: "barca", date: m.data_check_in || m.data_operazione || "", time: m.orario || "",
    title: m.nome_barca || "Barca", text: `Arrivo ${it(m.data_check_in) || "—"}${m.data_check_out ? ` · Partenza ${it(m.data_check_out)}` : " · ancora presente"}`, who: m.operatore || "",
  }));
  const works = (data.maintenance || []).map((m) => ({
    key: `m-${m.id}`, kind: "intervento", date: m.data_intervento || "", time: m.orario || "", title: m.tipo,
    text: [m.dimensione && `Dimensione ${m.dimensione}`, m.quantita != null && `Quantità ${m.quantita}`, m.note].filter(Boolean).join(" · "),
    who: [m.orario, m.operatore, m.certificazione && "certificato"].filter(Boolean).join(" · "),
  }));
  return [...boats, ...works].sort((a, b) => `${b.date} ${b.time}`.localeCompare(`${a.date} ${a.time}`));
}

function printTimeline(b, items) {
  const w = window.open("", "_blank");
  if (!w) return;
  const rows = items.map((e) => `<tr><td>${esc(it(e.date))}</td><td>${e.kind === "barca" ? "Barca ospitata" : "Intervento"}</td><td><b>${esc(e.title)}</b><br>${esc(e.text)}</td><td>${esc(e.who)}</td></tr>`).join("");
  w.document.write(`<html><head><title>Storico posto ${esc(b.pontile)} - ${esc(b.numero)}</title><style>body{font-family:Arial,sans-serif;padding:24px;color:#0b2540}h1{font-size:20px;margin:0}p{color:#555;font-size:12px}table{width:100%;border-collapse:collapse;font-size:12px;margin-top:16px}th,td{border-bottom:1px solid #ddd;padding:6px;text-align:left;vertical-align:top}th{background:#eef5f5}</style></head><body><h1>Porto di Roma · Storico posto barca ${esc(b.pontile)} - ${esc(b.numero)}</h1><p>${esc(b.dimensione || "")} · Stampato il ${new Date().toLocaleDateString("it-IT")}</p><table><thead><tr><th>Data</th><th>Tipo</th><th>Dettaglio</th><th>Operatore</th></tr></thead><tbody>${rows || '<tr><td colspan="4">Nessun evento registrato</td></tr>'}</tbody></table><script>window.onload=function(){window.print()}</script></body></html>`);
  w.document.close();
}

export function BerthTimeline({ data }) {
  const items = buildTimeline(data);
  return (
    <div data-testid="berth-timeline">
      <div className="flex justify-between items-center mb-4">
        <p className="text-sm text-slate-500">{items.length} {items.length === 1 ? "evento" : "eventi"}</p>
        <Button size="sm" variant="outline" className="rounded-full" onClick={() => printTimeline(data.berth, items)} data-testid="berth-timeline-print"><Printer className="w-4 h-4 mr-1" />Stampa PDF</Button>
      </div>
      {items.length === 0 ? <p className="text-sm text-slate-500" data-testid="berth-timeline-empty">Nessuna barca o intervento registrato.</p> : (
        <ol className="relative border-l-2 border-[var(--teal-soft)] ml-3 space-y-5">{items.map((e) => {
          const Icon = e.kind === "barca" ? Ship : e.title === "Altro" ? Anchor : Wrench;
          return (
            <li key={e.key} className="ml-6" data-testid={`berth-timeline-${e.key}`}>
              <span className={`absolute -left-[13px] w-6 h-6 rounded-full flex items-center justify-center ${e.kind === "barca" ? "bg-[var(--navy)]" : "bg-[var(--teal)]"}`}><Icon className="w-3.5 h-3.5 text-white" /></span>
              <p className="text-xs text-slate-400">{it(e.date) || "—"} · {e.kind === "barca" ? "Barca ospitata" : "Intervento"}</p>
              <p className="font-medium text-[var(--navy)]">{e.title}</p>
              {e.text && <p className="text-sm text-slate-600">{e.text}</p>}
              {e.who && <p className="text-xs text-slate-400">{e.who}</p>}
            </li>);
        })}</ol>)}
    </div>
  );
}
